
























import { Component, Vue, Prop } from "vue-property-decorator";

import { FormBase, FormInput, FormTextarea, FormFile, FormError, FormSubmit } from "./parts";

@Component({
    components: {
        FormBase,
        FormInput,
        FormError,
        FormSubmit
    }
})
export default class newsletterForm extends Vue {
    @Prop({ default: "large" }) mode?: "large" | "small";

    checked: boolean = false;

    payload: any = {
        email: ""
    };

    errorResponse: ErrorResponse = {
        status: 0,
        errors: []
    };

    private submit(form: FormClass) {
        if (!this.checked) {
            return;
        }
        // @ts-ignore
        axios
            .post(`/api/forms/newsletter-form`, this.payload)
            .then((response: any) => {
                // @ts-ignore
                if (window.hasOwnProperty("dataLayer") && dataLayer) {
                    // @ts-ignore
                    dataLayer.push({
                        event: "formSubmission",
                        formId: "3",
                        response: [
                            { name: "email", value: this.payload.email },
                            { name: "href", value: window.location.href },
                            { name: "pathname", value: window.location.pathname }
                        ]
                    });
                }

                this.payload = {
                    email: ""
                };

                this.checked = false;

                form.reset();
            })
            .catch((e: { response: { data: ErrorResponse } }) => {
                form.handleErrors(e.response.data);
            });
    }
}
